import Swal from 'sweetalert2'
import DOMPurify from 'dompurify'
export default {
    initializeSwalWithoutTimer(title, icon, text, hasConfirmationButton = false){
        return Swal.fire({
            title,
            icon,
            text,
            showConfirmButton: hasConfirmationButton,
        });
    },
    initializePrimarySwal(){
        return Swal.mixin({
            timer: 1500,
        });
    },
    showSwal(title, icon, text){
        return this.initializePrimarySwal().fire({
            title,
            icon,
            text,
            showConfirmButton: false,
        });
    },

    // pattern="[\u10A0-\u10FF\d !@#$^&\(\)\/*.+,_:]+"   >>
    checkName(value){
        return (/^[\u10A0-\u10FF \-0-9.+(),_]+$/.test(value));
    },
    checkEngName(value){
        return (/^[A-Za-z \-0-9.+(),_]+$/.test(value));
    },

    // % causes url malformation, it is excluded

    // pattern="[\u10A0-\u10FF\d !@#$^&\(\)\/*.+,_:?\-\\]+"   >>
    checkString(value){
        return (/^[\u10A0-\u10FF \-0-9.+(),_:@!#$^&*?;//%<>"'`=~|\[\]\{\}\\]+$/.test(String(value)));
    },
    // pattern="[A-Za-z\d !@#$^&\(\)\/*.+,_:?\-\\]+"   >>
    checkEngString(value){
        return (/^[A-Za-z \-0-9.+(),_:@!#$^&*?;//%<>"'`=~|\[\]\{\}\\]+$/.test(String(value)));
    },

    // pattern="[\p{L}\d !@#$^&\(\)\/*.+,_:?\-\\]+"   >>
    checkJustString(value){
        // return (/^[\u10A0-\u10FFA-Za-z \-0-9.+(),_:@!#$^&*?//\\]+$/.test(String(value)));
        return (/^[\p{L}\p{N} \-+().,_:@!#$^&*?/;%<>"'`=~|\[\]\{\}\\]+$/u.test(String(value)));

    },
    // pattern="[\p{L}\d !@#$^&\(\)\/*.+,_:?\-\\]*"   >>
    checkJustOptionalString(value){
        // return (/^[\u10A0-\u10FFA-Za-z \-0-9.+(),_:@!#$^&*?//\\]*$/.test(String(value)));
        return (/^[\p{L}\p{N} \-+().,_:@!#$^&*?/;%<>"'`=~|\[\]\{\}\\]*$/u.test(String(value)));

    },



    checkPhoneNumber(value) {
        return (/^[0-9]{9}$/.test(String(value)));
    },
    completePhoneNumber(number){
        return `+995${number}`;
    },
    checkNumber(value){
        return (/^[0-9]+$/.test(String(value)));
    },
    checkOptionalNumber(value){
        return (/^[0-9]*$/.test(String(value)));
    },
    checkPassword(value){
        let isValid = /^(?=.*[A-Z]+)(?=.*[a-z]+)(?=.*\d+)(?=.*[!@#$%^&*()_+,\.]+)[A-Za-z\d!@#$%^&*()_+,\.]{8,}$/.test(String(value));
        return isValid;
    },
    // pattern="[0-9]{11}" >>>
    checkPersonalNumber(value){
        return (/^[0-9]{11}$/.test(String(value)));
    },
    checkEmail(value){
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        let isValid = emailRegex.test(String(value));
        return isValid;
    },
    checkDateWithRegex(value){
        const regexTest = new RegExp(/^(\d{4}-\d{2}-\d{2})?$/);

        let result = regexTest.test(String(value));
        return result;
    },
    checkPhoto(file){
        if(file){
            const validImageTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/svg+xml'];
            if (!validImageTypes.includes(decodeURIComponent(file.type))) {
            return false;
            }
            return true;
        }
        return false;
    },
    checkJpeg(file){
        if(file){
            const validImageTypes = ['image/jpeg'];
            if (!validImageTypes.includes(decodeURIComponent(file.type))) {
            return false;
            }
            return true;
        }
        return false;
    },
    checkPhotoFormat(file, formatsArray){
        if(file){
            const validImageTypes = [...formatsArray];
            if (!validImageTypes.includes(decodeURIComponent(file.type))) {
            return false;
            }
            return true;
        }
        return false;
    },


    sanitazeStandard(word){
        let san = DOMPurify.sanitize(String(word),{ 
            USE_PROFILES: {html: true},
        })
        return san;
    },

    sanitazeAndPermitURI(word){
        let san = DOMPurify.sanitize(String(word),{ 
            USE_PROFILES: {html: true},
            FORBID_TAGS: ['a', 'router-link'],
            FORBID_ATTR: ['href'],
        })
        return san;
    },
    decodeHtml(html) {
        const doc = new DOMParser().parseFromString(html, "text/html");
        return doc.documentElement.textContent;
    },
    calculateAge(birthDateString) {
        const today = new Date();
        const birthDate = new Date(birthDateString);
        
        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDiff = today.getMonth() - birthDate.getMonth();
        const dayDiff = today.getDate() - birthDate.getDate();
        
        // Adjust age if birthday hasn't occurred yet this year
        if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
            age--;
        }
        
        return age;
    },
    getNextDay(date){
        let customDate = new Date(new Date(date).getTime() + 1000 * 60 * 60 * 24);
        return customDate;
    },
    getPreviousDay(date){
        let customDate = new Date(new Date(date).getTime() - 1000 * 60 * 60 * 24);
        return customDate;
    },
    getGeoMonth(index){
        const months = ["იან", "თებ", "მარ", "აპრ", "მაი", "ივნ", "ივლ", "აგვ", "სექ", "ოქტ", "ნოე", "დეკ"];
        return months[index];
    },
    get12HoursDate(dateText){
        let date = new Date(dateText);
        return `${date.getDate()} ${this.getGeoMonth(date.getMonth())}, ${date.getHours() % 12 || 12}.${String(date.getMinutes()).padStart(2, '0')} ${date.getHours() < 12?"AM":"PM"}`
    },
}